import styled, { css } from 'styled-components';
import { theme } from 'styles';

export const activeCategoryCss = css`
  border: solid 1px ${theme.color.info};
  cursor: pointer;
`;

export const ImageCategory = styled.div<{ isActive: boolean }>`
  padding: 8px 16px 8px 16px;
  border-radius: 20px;
  border: solid 1px ${theme.color.grey60};
  height: 40px;
  ${({ isActive }) => isActive && activeCategoryCss};

  :hover {
    cursor: pointer;
  }
`;

export const ImageWrapper = styled.div<{ isSelected: boolean }>`
  width: 400px;
  aspect-ratio: 3/1;
  overflow: hidden;
  border-radius: 10px;
  position: relative;
  border: ${({ isSelected }) => isSelected && `solid 5px ${theme.color.info}`};
`;

export const ImageButtonWrapper = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  padding: 12px;
  top: 0;
`;

export const ImageNumberWrapper = styled.div`
  background-color: ${theme.color.white};
  width: 24px;
  height: 24px;
  border-radius: 12px;
`;
export const ImageDeleteWrapper = styled.div`
  background-color: ${theme.color.white};
  width: 29px;
  height: 29px;
  border-radius: 4px;
`;
